// Shared topic catalog + matcher used by the global TopicFilter across all sections.
// Each topic has keywords; an item matches if its searchable text contains ANY keyword.

export const TOPIC_DEFS = {
  // Cross-section
  anxiety: { label: "Anxiety", keywords: ["anxi", "worry", "panic", "fear"] },
  cptsd: { label: "CPTSD", keywords: ["cptsd", "complex trauma"] },
  ptsd: { label: "PTSD", keywords: ["ptsd", "flashback"] },
  sleep: { label: "Sleep", keywords: ["sleep", "insomn", "night", "bed", "rest"] },
  boundaries: { label: "Boundaries", keywords: ["boundar"] },
  selfworth: { label: "Self-Worth", keywords: ["self-worth", "self worth", "worth", "self-esteem", "confidence"] },
  innerchild: { label: "Inner Child", keywords: ["inner child", "child"] },
  nervous: { label: "Nervous System", keywords: ["nervous", "vagus", "regulat", "polyvagal"] },
  relationships: { label: "Relationships", keywords: ["relation", "attach", "partner", "love"] },
  emotional: { label: "Emotional Regulation", keywords: ["emotion", "regulat", "mood", "feel"] },
  shadow: { label: "Shadow Work", keywords: ["shadow"] },
  grounding: { label: "Grounding", keywords: ["ground", "anchor", "present"] },
  breathing: { label: "Breathing", keywords: ["breath", "inhale", "exhale", "breathwork"] },
  trauma: { label: "Trauma Recovery", keywords: ["trauma", "recover", "heal"] },
  // Journal-specific
  daily: { label: "Daily Reflection", keywords: ["daily", "reflect", "morning", "evening", "today"] },
  // Dreams
  nightmares: { label: "Nightmares", keywords: ["nightmare", "bad dream"] },
  recurring: { label: "Recurring", keywords: ["recur", "repeat"] },
  lucid: { label: "Lucid", keywords: ["lucid"] },
  symbols: { label: "Symbols", keywords: ["symbol", "meaning", "interpret"] },
  // Sleep
  insomnia: { label: "Insomnia", keywords: ["insomn", "can't sleep", "awake"] },
  hygiene: { label: "Sleep Hygiene", keywords: ["hygien", "routine", "habit"] },
  prebed: { label: "Nervous System Before Bed", keywords: ["before bed", "wind down", "evening", "pre-sleep", "nervous"] },
  remedies: { label: "Natural Remedies", keywords: ["remedy", "herbal", "natural", "tea", "magnesium"] },
  // Breathing
  panic: { label: "Panic", keywords: ["panic", "attack"] },
  animal: { label: "Playful Breathing Adventures", keywords: ["bee", "lion", "snake", "crocodile", "bear", "monkey", "rabbit", "whale", "turtle", "dolphin", "butterfly", "koala", "leo", "bella", "sammy", "benny", "toby", "daisy", "koko", "animal", "playful"] },
  release: { label: "Emotional Release", keywords: ["release", "sigh", "let go", "exhale"] },
  // Somatic / Yoga
  yoga: { label: "Yoga", keywords: ["yoga", "asana", "nidra"] },
  restorative: { label: "Restorative", keywords: ["restor", "gentle", "rest"] },
  sensitive: { label: "Trauma-Sensitive", keywords: ["trauma-sensitive", "trauma sensitive", "gentle"] },
  coreg: { label: "Co-regulation", keywords: ["co-reg", "co reg", "together", "social"] },
  // Shadow
  anger: { label: "Anger", keywords: ["anger", "rage", "angry"] },
  grief: { label: "Grief", keywords: ["grief", "loss", "mourn"] },
  patterns: { label: "Patterns", keywords: ["pattern", "habit", "cycle"] },
  integration: { label: "Integration", keywords: ["integrat", "wholeness"] },
  // Reset / nervous-system
  overwhelm: { label: "Overwhelm", keywords: ["overwhelm", "stress"] },
  shutdown: { label: "Shutdown", keywords: ["shutdown", "freeze", "numb", "dorsal"] },
  // Community / Events
  support: { label: "Support", keywords: ["support", "help"] },
  stories: { label: "Healing Stories", keywords: ["story", "stories", "journey"] },
  qa: { label: "Q&A", keywords: ["q&a", "question", "answer", "ask"] },
  encouragement: { label: "Encouragement", keywords: ["encourage", "hope", "inspire"] },
  workshops: { label: "Workshops", keywords: ["workshop", "class"] },
  group: { label: "Group Healing", keywords: ["group", "circle"] },
  meditation: { label: "Meditation", keywords: ["meditat", "mindful"] },
  breathwork: { label: "Breathwork", keywords: ["breathwork", "breath"] },
  // Grounding subtopics
  fivesenses: { label: "5 Senses", keywords: ["sense", "5-4-3", "54321", "see", "hear", "touch"] },
  bodyscan: { label: "Body Scan", keywords: ["body scan", "scan", "progressive"] },
  safeplace: { label: "Safe Place", keywords: ["safe place", "visualiz", "imagery", "nature"] },
  soothe: { label: "Self-Soothe", keywords: ["soothe", "comfort", "kit"] },
} as const;

export type TopicId = keyof typeof TOPIC_DEFS;

export function topicList(ids: TopicId[]) {
  return ids.map((id) => ({ id, label: TOPIC_DEFS[id].label }));
}

export function matchesTopic(item: unknown, topic: string | null): boolean {
  if (!topic) return true;
  const def = TOPIC_DEFS[topic as TopicId];
  if (!def) return true;
  const hay = JSON.stringify(item).toLowerCase();
  return def.keywords.some((k) => hay.includes(k.toLowerCase()));
}
